import { render } from "./schools.vue?vue&type=template&id=dad66710&scoped=true"
import script from "./schools.vue?vue&type=script&lang=js"
export * from "./schools.vue?vue&type=script&lang=js"

import "./schools.vue?vue&type=style&index=0&id=dad66710&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad66710"]])

export default __exports__